import React from 'react';
import Unit from './Unit';
import Ad from "../ad/Ad";

const UnitList = (
	{
		units,
		onGetSkillInfo,
		availableSkills,
		pendingSkills,
		sortDir,
		sortBy,
		filters,
		displayView,
		searchResultIds,
		searchText,
	}) => {

	// FILTER UNITS
	if (filters.rarity) {

		const rarityFilter = filters.rarity;
		units = units.filter((unit) => {

			return rarityFilter.includes(unit.rarity.toString());
		});
	}

	if (filters.part && filters.part.length > 0) {

		const partFilter = filters.part;
		units = units.filter((unit) => {

			if (unit.part === 'Melee Weapon' || unit.part === 'Ranged Weapon') {

				const partType = unit['part_type'];
				return partFilter.includes(partType);
			}

			if (unit.part === 'Pilot') {

				const partType = unit['part_type'];
				return partFilter.includes(partType);
			}

			return partFilter.includes(unit.part);
		});
	}


	// SORT UNITS BY STATS
	if (sortBy.indexOf('stats') >= 0) {

		sortBy = sortBy.substring(6);
	}

	if ( sortDir === 'lowtohigh' ) {
		units.sort((a, b) => a[sortBy] < b[sortBy] ? -1 : 1);
	} else {
		units.sort((a, b) => a[sortBy] < b[sortBy] ? 1 : -1);
	}


	// SORT UNITS BY SKILLS
	if (sortBy.indexOf('skill') >= 0) {

		units = units.filter((unit) => {

			return unit[sortBy] !== null && unit[sortBy].trim().length > 0;
		});

		const getRankValue = ((rank) => {

			if (rank.indexOf('%') >= 0) {

				return rank.split('%')[0];
			} else {

				const value = {
					'S-': 95, 'S': 100, 'S+': 105,
					'A-': 85, 'A': 90, 'A+': 95,
					'B-': 75, 'B': 80, 'B+': 85,
					'C-': 65, 'C': 70, 'C+': 75,
					'D-': 55, 'D': 60, 'D+': 65,
					'?': 0
				};

				return value[rank];
			}
		});

		if ( sortDir === 'lowtohigh' ) {
			units.sort((a, b) => getRankValue(a[sortBy]) < getRankValue(b[sortBy]) ? -1 : 1);
		} else {
			units.sort((a, b) => getRankValue(a[sortBy]) < getRankValue(b[sortBy]) ? 1 : -1);
		}
	}

	// DON'T SHOW ANYTHING IF NO RESULT
	let unitComponent = [];
	const searchHasNoMatch = searchResultIds.length === 0 && searchText.trim().length > 0;

	if ( !searchHasNoMatch ) {

		// DISPLAY UNITS
		let counter = 1;
		unitComponent = units.map(unit => {

			if (searchResultIds.length > 0 && !searchResultIds.includes(unit.id.toString())) {

				return false;
			}

			counter++;

			if (counter % 8 === 0 && displayView === 'grid') {

				counter++;
				return (
					<div className='unit-ads' key={unit.id + '-ads-container'}>
						<Ad key={unit.id + '-ads'}/>
						<Unit key={unit.id} unit={unit} onGetSkillInfo={onGetSkillInfo} availableSkills={availableSkills}
							  pendingSkills={pendingSkills} sortKey={sortBy} />
					</div>
				);
			} else {

				return (
					<Unit key={unit.id} unit={unit} onGetSkillInfo={onGetSkillInfo} availableSkills={availableSkills}
						  pendingSkills={pendingSkills} sortKey={sortBy} />
				);
			}
		});
	}

	return (
			<div className={'unitlist br2 br--bottom pa2 w-100 view-' + displayView}>
				{unitComponent}
			</div>
		)
};

export default UnitList;